exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".copyright{flex-shrink:0;height:15px;width:100%;color:#888;font-family:Roboto;font-size:13px;line-height:15px;text-align:center;justify-content:center;padding-top:20px}.copyright a{color:#888}.copyright a:hover{color:#666}.copyright .mailText{color:#007bff}", ""]);

